'use client';
import React from 'react';
import PropTypes from 'prop-types';
import { LoadingView } from '@web/components';
import { useSessionCustomer } from '../customer';
import { Redirect } from './Redirect';
import { RedirectToLogin } from './RedirectToLogin';

/* this should be used for instances of standalone pages made
specifically for deeplinking to the APP. An example of this is:
- /account/box to redirect to the Box Screen
- /account/food-plan to redirect to the portion section modal */
export const RedirectToAccount = ({ to = '/account', replace = false }) => {
  const { isActive, isLoading: isCustomerLoading } = useSessionCustomer();

  if (!isCustomerLoading && !isActive) {
    return <RedirectToLogin />;
  }

  if (isCustomerLoading) {
    return <LoadingView />;
  }

  return <Redirect to={to} replace={replace} />;
};

RedirectToAccount.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  replace: PropTypes.bool,
};

RedirectToAccount.displayName = 'RedirectToAccount';
